module.exports = __webpack_public_path__ + "img/tjneh.03bd509f.jpg";